import { ContentChild, Directive, Input } from '@angular/core';
import { BoschUiCellDefDirective } from './bosch-ui-cell-def.directive';
import { BoschUiTableService } from '../bosch-ui-table.service';
import { BoschUiHeaderCellDefDirective } from './bosch-ui-header-cell-def.directive';

@Directive({
  selector: '[boschUiColumnDef]',
})
export class BoschUiColumnDefDirective<DataType> {
  @Input() set boschUiColumnDef(columnName: string) {
    this._columnName = columnName;
  }

  @ContentChild(BoschUiCellDefDirective)
  set cell(cell: BoschUiCellDefDirective<DataType>) {
    if (this._columnName) {
      this.tableService.addCell(this._columnName, cell);
    }
  }

  @ContentChild(BoschUiHeaderCellDefDirective)
  set headerCell(cell: BoschUiHeaderCellDefDirective<DataType>) {
    if (this._columnName) {
      this.tableService.addHeaderCell(this._columnName, cell);
    }
  }

  private _columnName: string | null = null;

  constructor(private tableService: BoschUiTableService<DataType>) {}
}
